<template>
  <div>
    <div class="mb-4">
      <p>{{ $t('※ 각 부서에서 관리감독자가 담당종사자를 직접 작성하는 페이지입니다.') }}</p>
      <p>{{ $t('※ 최초 작성 후 변동사항이 생겼을시 이전에 작성했던 문서를 열어 수정하여 저장합니다.') }}</p>
    </div>
    <!-- 기본정보 -->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      :types="['department', 'com_name', 'rank', 'writer_name', 'date']"
      :typeslabel="{
        date: '등록일',
      }"
    />

    <!--    종사자 소속-->
    <vs-row class="mt-4">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i>{{ $t('종사자 소속') }}</h5>
      </vs-col>
    </vs-row>
    <div class="writeGridContainer mt-4">
      <div class="writeGridLineItem">
        <div class="">{{ $t('회사명') }}</div>
        <span v-if="isPrint" class="print-input"> {{ form.fieldNames }} </span>
        <multiselect v-else :options="fieldNameList" v-model="form.fieldNames" :multiple="true" placeholder="" selectLabel="" deselectLabel="" :showNoResults="false">
          <template slot="option" slot-scope="props">
            <div>{{ props.option }}</div>
          </template>
        </multiselect>
      </div>
    </div>

    <!--    종사자 정보-->
    <vs-row class="mt-4">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i>{{ $t('종사자 정보') }}</h5>
      </vs-col>
    </vs-row>
    <div class="writeGridContainer mt-4">
      <div>
        <div class="">{{ $t('ID(사번)') }}</div>
        <p v-if="isPrint" class="print-input flex-1">{{ form.employee_id }}</p>
        <ml-input :readonly="board.readonly" v-else v-model="form.employee_id"/>
      </div>
      <div>
        <div>{{ $t('생년월일') }}</div>
        <p v-if="isPrint" class="print-input flex-1">
          {{ form.enc.date_of_birth }}
        </p>
        <date-selector v-else :readonly="board.readonly" v-model="form.enc.date_of_birth" />
      </div>
      <div>
        <div>{{ $t('부서') }}</div>
        <p v-if="isPrint" class="print-input flex-1">{{ form.targetCompany }}</p>
        <company-selector v-else v-model="form.department_name" class="w-full flex-1" :field-id="form.stdInfo.field_id" @select="selectCompany" />
      </div>

      <!-- PC 레이아웃 - 구분 -->
      <div v-if="!isMobile">
        <div>{{ $t('구분') }}</div>

        <vs-select autocomplete v-model="form.job_category">
          <vs-select-item v-for="divide in divideList" :key="divide" :text="$t(divide)" :value="divide" />
          <vs-select-item :text="$t('직접입력')" :value="divideList.includes(form.job_category) ? '' : form.job_category" />
        </vs-select>
        <ml-input v-if="!divideList.includes(form.job_category)" :readonly="board.readonly" v-model="form.job_category" />
      </div>

      <!-- Mobile 레이아웃 - 구분 -->
      <div v-if="isMobile" class="mobile-form-row">
        <div class="mobile-label">{{ $t('구분') }}</div>
        <div class="mobile-input-group">
          <vs-select autocomplete v-model="form.job_category" class="mobile-select">
            <vs-select-item v-for="divide in divideList" :key="divide" :text="$t(divide)" :value="divide" />
            <vs-select-item :text="$t('직접입력')" :value="divideList.includes(form.job_category) ? '' : form.job_category" />
          </vs-select>
          <ml-input v-if="!divideList.includes(form.job_category)" :readonly="board.readonly" v-model="form.job_category" class="mobile-input" />
        </div>
      </div>

      <!-- PC 레이아웃 - 직종 -->
      <div v-if="!isMobile">
        <div>{{ $t('직종') }}</div>
        <vs-select autocomplete v-model="form.employment_type">
          <vs-select-item v-for="job in jobList" :key="job" :text="$t(job)" :value="job" />
          <vs-select-item :text="$t('직접입력')" :value="jobList.includes(form.employment_type) ? '' : form.employment_type" />
        </vs-select>
        <ml-input v-if="!jobList.includes(form.employment_type)" :readonly="board.readonly" v-model="form.employment_type" />
      </div>

      <!-- Mobile 레이아웃 - 직종 -->
      <div v-if="isMobile" class="mobile-form-row">
        <div class="mobile-label">{{ $t('직종') }}</div>
        <div class="mobile-input-group">
          <vs-select autocomplete v-model="form.employment_type" class="mobile-select">
            <vs-select-item v-for="job in jobList" :key="job" :text="$t(job)" :value="job" />
            <vs-select-item :text="$t('직접입력')" :value="jobList.includes(form.employment_type) ? '' : form.employment_type" />
          </vs-select>
          <ml-input v-if="!jobList.includes(form.employment_type)" :readonly="board.readonly" v-model="form.employment_type" class="mobile-input" />
        </div>
      </div>
      <div>
        <div>{{ $t('직급') }}</div>
        <p v-if="isPrint" class="print-input flex-1">{{ form.job_title }}</p>
        <ml-input :readonly="board.readonly" v-else v-model="form.job_title"/>
      </div>

      <div>
        <div>{{ $t('성명') }}</div>
        <p v-if="isPrint" class="print-input flex-1">{{ form.enc.full_name || form.full_name }}</p>
        <ml-input :readonly="board.readonly" v-else v-model="form.enc.full_name"/>
      </div>
      <div>
        <div>{{ $t('최종 입사일') }}</div>
        <p v-if="isPrint" class="print-input">{{ form.hire_date }}</p>
        <date-selector v-else v-model="form.hire_date" :readonly="board.readonly" />
      </div>
      <div>
        <div>{{ $t('현보직일') }}</div>
        <p v-if="isPrint" class="print-input">{{ form.current_position_date }}</p>
        <date-selector v-else v-model="form.current_position_date" :readonly="board.readonly" />
      </div>

      <div>
        <div>{{ $t('연락처') }}</div>
        <p v-if="isPrint" class="print-input flex-1">{{ form.enc.contact_number || form.contact_number }}</p>
        <ml-input :readonly="board.readonly" v-else v-model="form.enc.contact_number"/>
      </div>
      <div>
        <div>{{ $t('퇴임일') }}</div>
        <p v-if="isPrint" class="print-input">{{ form.retirement_date }}</p>
        <date-selector v-else v-model="form.retirement_date" :readonly="board.readonly" />
      </div>
    </div>

    <!--    안전·보건 교육 이수 현황-->
    <vs-row class="mt-4">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i>{{ $t('안전·보건 교육 이수 현황') }}</h5>
      </vs-col>
    </vs-row>
    <!-- Desktop 테이블 레이아웃 -->
    <div v-show="windowWidth >= 768" class="mt-4">
      <table class="border-left border-right">
        <thead>
          <tr style="background-color: #fafafa">
            <th v-for="(item, index) in keys" :key="index" style="padding-top: 8px; padding-bottom: 8px">{{ $t(item) }}</th>
          </tr>
        </thead>
        <tbody>
          <tr style="background-color: #ffffff">
            <!-- 각 td의 폭을 같게 설정한다 -->
            <td v-for="(item, index) in educationHours" :key="index" class="hoursTd" :style="{ width: `${100 / keys.length}%` }">
              <div v-if="item <= 0" class="flex justify-center">
                <img src="@/assets/icons/education_red_dot.svg" :alt="floatToTimeString(item)" />
              </div>
              <div v-else class="flex justify-center">{{ floatToTimeString(item) }}</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Mobile 카드 레이아웃 -->
    <div v-show="windowWidth < 768" class="mt-4 mobile-education-container">
      <div class="mobile-education-cards">
        <div
          v-for="(item, index) in keys"
          :key="index"
          class="mobile-education-card"
          :class="{ 'total-card': index === keys.length - 1 }"
        >
          <div class="card-content">
            <div class="education-type">{{ $t(item) }}</div>
            <div class="education-status">
              <div v-if="educationHours[index] <= 0" class="status-indicator">
                <img src="@/assets/icons/education_red_dot.svg" :alt="floatToTimeString(educationHours[index])" />
<!--                <span class="status-text">미이수</span>-->
              </div>
              <div v-else class="status-hours">{{ floatToTimeString(educationHours[index]) }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 플로팅 버튼과의 간섭 방지를 위한 하단 여백 -->
    <div class="bottom-spacing"></div>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import DateSelector from "@/components/selector/DateSelector.vue";
import Multiselect from "vue-multiselect";
import CompanySelector from "@/components/selector/CompanySelector.vue";
import { required } from 'vuelidate/lib/validators';

export default {
  components: {
    CompanySelector,
    DateSelector,
    FieldSelectModule,
    FileUploadModule,
    Multiselect,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  validations: {
    form: {
      hire_date: {},
      retirement_date: {}
    },
    // 커스텀 검증을 루트 레벨로 이동
    dateRangeValid() {
      if (!this.form.hire_date || !this.form.retirement_date) {
        return true;
      }
      return new Date(this.form.hire_date) <= new Date(this.form.retirement_date);
    }
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }

        if (!!value.field_names && 0 < value.field_names.length && !value.fieldNames) {
          this.form.fieldNames = JSON.parse(JSON.stringify([...this.form.fieldNames, ...value.field_names]));
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);

        // this.postId 값이 존재하고, this.employeeDetail 값이 빈 오브젝트일 경우, loadEmployeeDetail 메서드를 실행
        if (this.postId && Object.keys(this.employeeDetail).length === 0) {
          this.loadEmployeeDetail();
        }
      },
    },
    "form.fieldNames": {
      immediate: true,
      deep: true,
      handler(/*value*/) {
        const fields = [];
        if (this.form.fieldNames.length > 0) {
          for (const fieldName of this.form.fieldNames) {
            const field = this.fieldList.find((e) => e.field_name === fieldName);
            if (field && field.id) {
              fields.push(field.id);
            }
          }
        }
        this.form.fields = fields;
      },
    },
  },
  computed: {
    isMobile() {
      return this.windowWidth < 768;
    },
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
    postId() {
      return parseInt(this.$route.params.postId);
    },
    fieldList() {
      if (this.$store.state.project.fieldListInfo.data) {
        return this.$store.state.project.fieldListInfo.data;
      }
      return [];
    },
    fieldNameList() {
      if (this.$store.state.project.fieldListInfo.data) {
        const list = [];
        for (const field of this.$store.state.project.fieldListInfo.data) {
          list.push(field.field_name);
        }

        return list;
      }

      return [];
    },
  },
  data() {
    return {
      // 종사자 상세 정보 조회를 시작했을 경우 true
      isStartLoadEmployeeDetail: false,
      employeeDetail: {},

      // 반응형 윈도우 크기 감지
      windowWidth: window.innerWidth,

      keys: ["정기안전교육", "특별안전보건교육", "채용시 안전교육", "작업내용 변경시 안전교육", "안전보건총괄책임자 교육", "안전보건관리책임자 교육", "관리감독자 안전교육", "MSDS", "기타", "계"],
      educationHours: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      form: {
        stdInfo: {},
        fileList: [],
        enc: {
          date_of_birth: "", // 생년월일
          full_name: "", // 성명
          contact_number: "", // 연락처
        },
        employee_id: "", // 사번
        department_name: "", // 부서명 (no)
        job_category: "", // 구분
        employment_type: "", // 직종
        job_title: "", // 직급

        hire_date: "", // 최종 입사일
        current_position_date: "", // 현보직일
        retirement_date: "", // 퇴임일

        fieldNames: [],
        field_names: [],
        targetCompany: "", // 부서명
      },

      divideList: [
        "경영책임자",
        "안전보건총괄책임자",
        "안전보건관리책임자",
        "안전팀장",
        "보건팀장",
        "안전보건팀장",
        "관리감독자",
        "안전관리자",
        "안전담당자",
        "보건관리자",
        "보건담당자",
        "담당자",
        "반장",
        "신호수",
        "기타"
      ],
      jobList: [
        "사무직",
        "현장직",
        "기타"
      ],
    };
  },
  mounted() {
    this.loadFieldList();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    async loadFieldList() {
      const projectId = this.projectId;
      const page = 1;
      const perPage = 1000;

      await this.$store.dispatch("project/LOAD_FIELD_LIST", { projectId, page, perPage, showAll: 1 });
    },
    selectCompany(value) {
      this.form.targetCompany = value.com_name;
    },
    // 종사자 정보 상세 정보를 불러온다
    async loadEmployeeDetail() {
      if (this.isStartLoadEmployeeDetail) {
        return;
      }

      this.isStartLoadEmployeeDetail = true;
      this.employeeDetail = await this.$store.dispatch("employee/LOAD_EMPLOYEE_DETAIL", {
        projectId: this.projectId,
        post_id: this.postId,
      });

      // this.employeeDetail.education 배열을 조회한다.
      // education_type 값이 keys 배열에 존재하는 값이면, education_hours 값을 educationHours 배열에 입력한다
      if (this.employeeDetail.education) {
        let sum = 0;
        for (const education of this.employeeDetail.education) {
          const index = this.keys.indexOf(education.education_type);
          if (index > -1) {
            this.educationHours[index] = education.total_education_hours;
            sum += education.total_education_hours;
          }
        }
        // this.educationHours 마지막 값에 합계를 입력한다.
        this.educationHours[this.educationHours.length - 1] = sum;
      }

      this.isStartLoadEmployeeDetail = false;
    },
    // float 숫자를 시간 문자열로 바꾼다. 예를 들어서 4.5를 04:30으로 바꾼다.
    floatToTimeString(floatNumber) {
      const hour = Math.floor(floatNumber);
      const minute = Math.round((floatNumber - hour) * 60);

      return `${hour.toString().padStart(2, "0")}시간 ${minute.toString().padStart(2, "0")}분`;
    },

    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (!this.$v.dateRangeValid) {
          return "퇴임일은 최종 입사일 이후로 설정해야 합니다.";
        }
      }
    }
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;

table {
  width: 100%;
  border-collapse: collapse;
}

th,
td {
  border: $border;
  padding: 15px;
  text-align: center;
  font-weight: 500;
  font-size: 14px;
}

tr:nth-child(1) {
  background-color: #fafafa;
}

tr:nth-child(2n + 1) td {
  border-top: none;
}

tr:nth-child(2n) td {
  border-bottom: none;
}

tr:first-child th:first-child,
tr:first-child td:first-child {
  border-left: none;
}

tr:first-child th:last-child,
tr:first-child td:last-child {
  border-right: none;
}

/* .hoursTd 마지막 칸은 bold 적용 */
td.hoursTd:last-child {
  font-weight: bold;
}

/* 모바일 교육 현황 카드 스타일 */
.mobile-education-container {
  padding: 16px 0;
}

.mobile-education-cards {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.mobile-education-card {
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
}

.mobile-education-card:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.mobile-education-card.total-card {
  background: #f8f9fa;
  border-color: #6c757d;
  font-weight: bold;
}

.card-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  align-items: center;
  min-height: 44px; /* 터치 친화적 최소 높이 */
}

.education-type {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  line-height: 1.4;
}

.total-card .education-type {
  font-weight: bold;
  color: #495057;
}

.education-status {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.status-indicator {
  display: flex;
  align-items: center;
  gap: 8px;
}

.status-indicator img {
  width: 16px;
  height: 16px;
}

.status-text {
  font-size: 12px;
  color: #dc3545;
  font-weight: 500;
}

.status-hours {
  font-size: 14px;
  font-weight: 600;
  color: #28a745;
  text-align: right;
}

.total-card .status-hours {
  font-size: 16px;
  font-weight: bold;
  color: #495057;
}

/* 하단 여백 - 플로팅 버튼과의 간섭 방지 */
.bottom-spacing {
  height: 80px; /* 플로팅 버튼 높이 + 추가 여백 */
}

/* 모바일 폼 스타일 */
.mobile-form-row {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 16px;
  min-height: 44px; /* 터치 친화적 최소 높이 */
}

.mobile-label {
  flex-shrink: 0;
  min-width: 60px;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  line-height: 1.4;
  padding-top: 12px; /* vs-select와 높이 맞춤 */
}

.mobile-input-group {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.mobile-select {
  width: 100% !important;
}

.mobile-input {
  width: 100% !important;
}

/* 인쇄 시 PC 레이아웃 강제 적용 */
@media print {
  .mobile-education-container {
    display: none !important;
  }

  .mt-4:has(table) {
    display: block !important;
  }

  /* 인쇄 시 모바일 레이아웃 숨기기 */
  .mobile-form-row {
    display: none !important;
  }
}
</style>
